import { render, staticRenderFns } from "./CertificateDetail.vue?vue&type=template&id=67fb3bf0&scoped=true&"
import script from "./CertificateDetail.vue?vue&type=script&lang=js&"
export * from "./CertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetail.vue?vue&type=style&index=0&id=67fb3bf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb3bf0",
  null
  
)

export default component.exports